import AttachmentsList from 'components/AttachmentsList'
import React from 'react'
import { kinshipRelationshipTypes } from 'utils/constants/DueDiligenceRelations'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayAttorneyActivites(props) {
  const { questionData } = props
  const classes = styles()

  const buildAttorneyActivity = (activityInfo) => {
    return (
      <div className={classes.answersContainer} key={activityInfo.key}>
        <p>
          <span>Nome completo do cliente: </span>
          {activityInfo.name}
        </p>
        <p>
          <span>CPF: </span>
          {activityInfo.cpf}
        </p>

        <p>
          <span>Grau de parentesco: </span>
          {kinshipRelationshipTypes[activityInfo.degree_of_kinship]}
        </p>
        <AttachmentsList attachments={activityInfo.attachments} />
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento das atividades de procurador:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não atua como procurador."
        funcBuildItem={buildAttorneyActivity}
      />
    </div>
  )
}

export default DisplayAttorneyActivites
